.container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.input {
  background: white;
  border: 1px solid var(--color-border);
  border-radius: 2px;
  font-size: var(--font-size-normal);
  color: var(--color-text);
  display: inline-block;
  padding: 0.5rem;
  width: 85%;
}

.message {
  font-size: 0.875rem;
}

/* A long link breaks inside the narrow modal instead of running past its edge. */
.text {
  min-width: 0;
  overflow-wrap: anywhere;
}
